const lbaViewGrid = angular.module('app.lbaViewGrid', ['ngTasty']);

lbaViewGrid.controller('lbaViewGridCtrl', require('./lbaViewGridCtrl'));
lbaViewGrid.directive('lbaViewGrid', require('./lbaViewGridDir'));

export default lbaViewGrid;



// WEBPACK FOOTER //
// ./src/components/lbaViewGrid/index.js